import React from 'react';

import './Articles.css';
import API from "../../components/api";
import {SERVER_URL} from "../../config";

import {Link} from "react-router-dom";
import Utils from "../../utils";


class ArticlesPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            articles: []
        }

        this.renderArticles = (articles) => {
            return <>
                {
                    articles.map(article => {
                        return <Link className='article' to={`/articles/${article.id}/`}>
                            <img src={SERVER_URL + article.image} alt=''/>
                            <div className='content'>
                                <div className='title'>
                                    {article.title}
                                </div>
                                <div className='subtitle'>
                                    {article.subtitle}
                                </div>
                                <div className='date'>
                                    {article.published_date}
                                </div>
                            </div>
                        </Link>
                    })
                }
            </>
        }
    }

    componentDidMount() {
        Utils.setPageTitle('Статьи')

        API.getArticlesPage()
            .then(data => this.setState({articles: data}))
            .catch(() => {
            })
    }

    render() {
        return <div className='articles-page'>
            <div className='page'>
                <div className='header'>
                    <div className='title'>
                        Статьи
                    </div>
                </div>
                <div className='articles'>
                    {this.renderArticles(this.state.articles)}
                </div>
            </div>
        </div>
    }
}


export default ArticlesPage;
